import React, { useState } from 'react';
import Header from '../components/header';
import corazonImg from '../image/Beneficos/corazon.png';
import cerebroImg from '../image/Beneficos/cerebro.png';
import inmunologicoImg from '../image/Beneficos/inmunologico.png';
import digestivoImg from '../image/Beneficos/gastrointestinal.png';
import cabelloImg from '../image/Beneficos/cabello.png';
import pielImg from '../image/Beneficos/piel.png';
import antioxidanteImg from '../image/Beneficos/Antioxidante.png';
import '../styles/beneficios.css';
import { useLanguage } from '../context/LanguageContext';

const benefitsData = {
  es: [
  {
    title: 'Cerebro',
    description:
      'Estimula tu mente y potencia tus funciones cognitivas.',
    moreInfo:
      'Las semillas de Sacha Inchi aportan varios aminoácidos esenciales, como la leucina, tirosina, isoleucina, lisina y triptófano. Este último es crucial para la producción de serotonina, que influye en el estado de ánimo, el sueño y la gestión del estrés. Además brinda soporte cognitivo gracias a la presencia de antioxidantes que favorecen a la función cerebral, mejorando la memoria y la concentración, aspectos importantes en períodos de alta demanda mental.',
    icon: cerebroImg
  },
  {
    title: 'Sistema Inmunológico',
    description:
      'Fortalece tu sistema inmunitario con hábitos saludables y cuidados integrales.',
    moreInfo:
      'Estas semillas contienen aproximadamente un 22–35% de proteína, la cual de la mano de la alta cantidad de fibra promueve la sensación de llenura, ayudando a controlar el apetito y favoreciendo el mantenimiento o pérdida de peso y la digestión saludable, gracias a regulación en el tránsito intestinal, previniendo el estreñimiento y promoviendo una flora intestinal equilibrada.',
    icon: inmunologicoImg
  },
  {
    title: 'Propiedades antinflamatorias',
    description:
      'Disminuye la inflamación y optimiza tu bienestar general.',
    moreInfo:
      'La combinación de los ácidos grasos poliinsaturados y los antioxidantes ayuda a disminuir procesos inflamatorios en el cuerpo, lo que resulta beneficioso para prevenir y tratar afecciones crónicas, como la artritis, y para mejorar la recuperación post-ejercicio.',
    icon: digestivoImg
  },
  {
    title: 'Cabello y uñas',
    description:
      'Realza la belleza y fortaleza de tu cabello y uñas con nutrientes esenciales.',
    moreInfo:
      'La aplicación del aceite favorece el crecimiento y la reparación del cabello y fortalece las uñas, ayudando a reducir la caída y a mejorar la apariencia general. Adicional, la combinación de nutrientes presentes estimula el crecimiento capilar, aportando brillo y vitalidad.',
    icon: cabelloImg
  },
  {
    title: 'Piel',
    description:
      'Destaca el resplandor natural de tu piel a través de cuidados internos y externos.',
    moreInfo:
      'Estas semillas contienen aproximadamente un 22–35% de proteína, la cual de la mano de la alta cantidad de fibra promueve la sensación de llenura, ayudando a controlar el apetito y favoreciendo el mantenimiento o pérdida de peso y la digestión saludable, gracias a regulación en el tránsito intestinal, previniendo el estreñimiento y promoviendo una flora intestinal equilibrada.',
    icon: pielImg
  },
  {
    title: 'Antioxidante natural',
    description:
      'Defiende tu organismo contra el estrés oxidativo con antioxidantes puros.',
    moreInfo:
      'El Sacha Inchi es rico en vitaminas A y E, las cuales actúan como potentes antioxidantes. Estos antioxidantes ayudan a neutralizar los radicales libres (moléculas inestables que pueden dañar proteínas, lípidos, ARN y ADN) y protegen al organismo del estrés oxidativo. Las propiedades antioxidantes del aceite extraído de sus semillas se deben, en parte, a su contenido en fenoles, tocoferoles y carotenoides. Los tocoferoles, en particular, son antioxidantes naturales, además estos compuestos se han asociado con el retraso del envejecimiento celular y la reducción del riesgo de enfermedades cardiovasculares.',
    icon: antioxidanteImg
  },
  {
    title: 'Corazón',
    description:
      'Cuida tu corazón manteniéndolo vigoroso y protegido contra riesgos cardiovasculares.',
    moreInfo:
      'El Sacha Inchi es una fuente esencial de ácidos grasos omega-3 y omega-6, gracias a su contenido de ácido alfa-linolénico y ácido linoleico. Estos ácidos grasos son beneficiosos para la salud, ya que ayudan a controlar el síndrome cardiometabólico, incluyendo la enfermedad coronaria y la hipertensión, contribuyendo en la reducción del colesterol cuando se utilizan como complemento alimenticio. Dado que el organismo no puede sintetizar estos ácidos grasos, por la falta de enzimas (delta-12 y delta-15 desaturasas), deben incorporarse a través de la dieta. Los altos niveles de omega-3 presentes en el Sacha Inchi ayudan a disminuir el colesterol LDL (el “malo”) y a aumentar el HDL (el “bueno”), protegiendo el corazón y mejorando la circulación sanguínea. Además, estos ácidos grasos colaboran en la regulación de la presión arterial, reduciendo el riesgo de hipertensión y otras complicaciones cardiovasculares.',
    icon: corazonImg
  }
  ],
  en: [
    {
      title: 'Brain',
      description: 'Stimulates your mind and supports cognitive performance.',
      moreInfo:
        'Sacha Inchi seeds provide essential amino acids such as leucine, tyrosine, isoleucine, lysine, and tryptophan. Tryptophan supports serotonin production, helping mood, sleep quality, and stress management. Its antioxidants also support memory and concentration during periods of high mental demand.',
      icon: cerebroImg
    },
    {
      title: 'Immune System',
      description: 'Strengthens your defenses with a healthier daily routine.',
      moreInfo:
        'These seeds contain approximately 22-35% protein and a high fiber content, which promotes satiety and helps appetite control. They also support digestion by improving intestinal transit and contributing to better gut balance.',
      icon: inmunologicoImg
    },
    {
      title: 'Anti-inflammatory Properties',
      description: 'Helps reduce inflammation and supports overall wellness.',
      moreInfo:
        'The combination of polyunsaturated fatty acids and antioxidants helps reduce inflammatory processes in the body. This can support recovery after exercise and help lower risk factors associated with chronic inflammation.',
      icon: digestivoImg
    },
    {
      title: 'Hair and Nails',
      description: 'Supports stronger, healthier hair and nails.',
      moreInfo:
        'Topical use of Sacha Inchi oil helps nourish and repair hair while strengthening nails. The nutrient profile helps improve shine, resilience, and overall appearance.',
      icon: cabelloImg
    },
    {
      title: 'Skin',
      description: 'Enhances your natural glow from inside and out.',
      moreInfo:
        'Its healthy fats and antioxidant profile help keep skin hydrated and protected. Consistent use can support softness, elasticity, and a healthier skin look.',
      icon: pielImg
    },
    {
      title: 'Natural Antioxidant',
      description: 'Protects the body from oxidative stress.',
      moreInfo:
        'Sacha Inchi is rich in vitamins A and E. These antioxidants help neutralize free radicals and protect cells from oxidative damage. Compounds such as phenols, tocopherols, and carotenoids contribute to its protective effect and may support cardiovascular health.',
      icon: antioxidanteImg
    },
    {
      title: 'Heart',
      description: 'Supports cardiovascular health with essential fatty acids.',
      moreInfo:
        'Sacha Inchi is a source of omega-3 and omega-6 fatty acids. These nutrients may help improve lipid profile by reducing LDL and supporting HDL, while also helping blood pressure regulation and circulation. Since the body cannot synthesize these fats efficiently, dietary intake is essential.',
      icon: corazonImg
    }
  ]
};

const Beneficios = () => {
  const { language } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);
  const localizedBenefits = benefitsData[language];
  const activeBenefit = localizedBenefits[activeIndex];

  const copy = {
    es: {
      eyebrow: 'Lo mejor del Sacha Inchi',
      title: 'Sacha Inchi',
      description:
        'Por su alto contenido en Omega 3,6 y 9 fortalece el corazon. Mantien tu corazon fuerte y saludable, reduciendo el riesgo de enfermedades cardiovasculares.',
      featured: 'Beneficio destacado',
      listAria: 'Lista de beneficios'
    },
    en: {
      eyebrow: 'The best of Sacha Inchi',
      title: 'Sacha Inchi',
      description:
        'Its high Omega 3, 6 and 9 content supports heart health and helps reduce cardiovascular risk factors.',
      featured: 'Featured benefit',
      listAria: 'Benefits list'
    }
  };

  const t = copy[language];

  return (
    <div className="beneficios-container page-shell">
      <Header />
      <div className="beneficios-main">
        <p className="section-eyebrow">{t.eyebrow}</p>
        <h1 className="beneficios-title">{t.title}</h1>
        <p className="main-description">
          {t.description}
        </p>
        <hr className="beneficios-separator" />
        <div className="beneficios-layout">
          <aside className="benefit-list" aria-label={t.listAria}>
            {localizedBenefits.map((benefit, index) => (
              <button
                key={benefit.title}
                className={`benefit-list-item ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
                type="button"
              >
                <span>{benefit.title}</span>
              </button>
            ))}
          </aside>

          <article className="benefit-showcase">
            <div className="benefit-showcase-head">
              <img src={activeBenefit.icon} alt={activeBenefit.title} className="benefit-icon" />
              <div>
                <p className="benefit-kicker">{t.featured}</p>
                <h2 className="benefit-title">{activeBenefit.title}</h2>
              </div>
            </div>

            <p className="benefit-description">{activeBenefit.description}</p>
            <p className="benefit-more-info">{activeBenefit.moreInfo}</p>
          </article>
        </div>
      </div>
    </div>
  );
};

export default Beneficios;
